<template>
  <div class="contaner">
   <div class="nav" style="color:#000000" :style="{'backgroundColor':(status==1||status==2||status==0)?'#ffffff':'#F5F5F5'}">
	  <div class="nav-top"  v-if="status==1||status==2||status==0" >
		<div class="back" v-if="pageType=='pageCustom'"  @click="back" >
         <img src="../../../static/black_return.png" alt="">
		</div>
		<span>好友代付</span>
	</div>
</div>
    <div v-if="status == 0 || status == 3">
      <div v-if="status == 0" class="title">
        <p>您的订单已创建成功</p>
        <p>快转发好友帮你付款吧</p>
      </div>
      <div class="card"  :style="{ marginTop:status==3? 45 / 16 + 'rem':'' }">
        <img :src="avatar" alt="" />
        <span>{{ nickName }}</span>
        <p>我正在看一本很好看的小说，帮我充一点书币吧，谢谢啦！</p>
        <p class="line"></p>
        <p>代付金额</p>
        <p>
          {{ needMoney
          }}<span style="font-size: 0.75rem; color: #333333">元</span>
        </p>
        <div v-if="status == 0" class="pay-btn" @click="sendWX">
          发送给微信好友
        </div>
        <div v-if="status == 3" class="pay-btn" @click="gotoPay">立即支付</div>
      </div>
      <span class="tips-bottom" v-if="status == 3" @click="checkCity"
        >点击查看海量好书></span
      >
    </div>
    <div v-if="status == 1 || status == 4" class="success">
      <img src="../../../static/success-icon.png" alt="" />
      <p>该订单已代支付完成</p>
      <span v-if="status == 4" @click="checkCity">点击查看海量好书 ></span>
      <span v-if="status == 1" @click="goRead">点击继续阅读精彩内容 ></span>
    </div>
    <div v-if="status == 2 || status == 5" class="success">
      <img src="../../../static/orderError.png" alt="" />
      <p>该订单已失效</p>
      <span v-if="status == 5" @click="checkCity">点击查看海量好书 ></span>
      <span v-if="status == 2" @click="goRead">点击继续阅读精彩内容 ></span>
    </div>
    <buyBook
      :showBuyMask="showBuyMask"
      :countCurrency="countCurrency"
      @buyChange="buyChange"
      :userCurrency="userCurrency"
    ></buyBook>
    <div  class="mask-img"   v-if="showTips"
      @click="showTips = false">
      <img
      src="../../../static/share_stap1.png"
      alt=""
    />
  <img
      src="../../../static/share_stap2.png"
      alt=""
    />

    </div>
  </div>
</template>
<script>
import { Toast, MessageBox } from "mint-ui";
import navBar from "../components/navbar.vue";
import buyBook from "../components/buyBook.vue";
import wx from "weixin-js-sdk";
export default {
  components: {
    navBar,
    buyBook,
  },
  data() {
    return {
      showTips: false,
      countCurrency: 0, //整本书币，
      showBuyMask: false, //显示整本订购弹窗
      userCurrency: 0, //用户剩余书币
      purchaseWholeBook: 0,
      bookInfo: {
        bookId: "",
        chapterOrder: "",
        chapterId: "",
      },
      status: -1, //0 用户，并且没有支付 1，用户，已支付完成 2，用户，订单失效 3，代付人 没有支付，4 代付人 已支付完成 5，代付人 订单失效
      needMoney: "",
      orderNo: "",
      nickName: "",
      avatar: "",
      pageType: "",
      agencyOpenid: "",
      officialCode: "",
      isShowback:false,
      routePages:0
    };
  },
  mounted() {
    this.needMoney = this.$route.query.needMoney;
    this.orderNo = this.$route.query.orderNo;
    this.pageType = this.$route.query.pageType;
    this.officialCode = this.$route.query.officialCode;
    this.routePages = window.history.length;
    var openid = this.$base.getStorage("openid");
    if (!openid) {
      //静默登录手动登录
      // this.wechatLogin();
    } else {
      //获取订单状态
      this.agencyOpenid = openid;
      this.getAgentPayInfo();
    }
    this.$commonApi.setTitle();
  },
  methods: {
       getOrderStatus() {
      if (
        this.$base.getStorage("orderNum") &&
        this.$base.getStorage("isActivity")
      ) {
        var params = {
          orderNo: this.$base.getStorage("orderNum"),
          currentPageType: 1,
        };
        this.$api.getOrderStatus(params).then((res) => {
          this.$base.removeStorage("orderNum");
          this.$base.removeStorage("isActivity");
          if (res.status == 1) {
            Toast({
              message: res.message,
            });
          }
        });
      }
    },
    getAgentPayInfo() {
      var params = {
        agencyOpenid: this.agencyOpenid, //代付人openid
        orderNo: this.orderNo,
      };
      //isAgencyPayment 用户 1， 是代支付人 0
      //payStatus 已付款：1，未付款：0  2.失效
      this.$api.getAgentPayInfo(params).then((res) => {
        if (res.status == 1) {
          this.nickName = res.data.nickName;
          this.avatar = res.data.headImgurl;
          if (res.data.isAgencyPayment == 1 && res.data.payStatus == 0) {
            this.status = 0;
          } else if (res.data.isAgencyPayment == 1 && res.data.payStatus == 1) {
            this.status = 1;
          } else if (res.data.isAgencyPayment == 1 && res.data.payStatus == 2) {
            this.status = 2;
          } else if (res.data.isAgencyPayment == 0 && res.data.payStatus == 0) {
            this.status = 3;
          } else if (res.data.isAgencyPayment == 0 && res.data.payStatus == 1) {
            this.status = 4;
          } else if (res.data.isAgencyPayment == 0 && res.data.payStatus == 2) {
            this.status = 5;
          }
          if(this.status==0){
            this.share();
          }
          if (res.data.isAgencyPayment==1) {
               this.getContuneRead();
               this.getOrderStatus();
          }
        }
      });
    },
    sendWX() {
      this.showTips = true;
    },
    share() {
      var realUrl = window.location.href; //window.location.href
      this.$api.getSignature({ realUrl: realUrl }).then((res) => {
        if (res.status == 1) {
          this.jweixinShare(res.data);
        }
      });
    },
    jweixinShare(data) {
      var params='#/pages/bookFindpay/index?orderNo='+this.orderNo+'&needMoney='+this.needMoney+'&officialCode='+this.officialCode
      var url = window.location.origin + "/" +  params;
      var that = this;
      console.log(url);
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.appId, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名
        jsApiList: data.jsApiList, //必填，需要使用的JS接口列表
      });
      wx.error(function (res) {
        console.log(res);
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      });
      wx.ready(() => {
        wx.updateAppMessageShareData({
          //测试分享到朋友
          title: "滴水之恩，必涌泉相报", // 标题
          desc: "我正在看一本书，能帮我付下钱吗？谢谢啦~", // 分享描述
          link: url,
          imgUrl: that.avatar, // 分享图标
          success: () => {
            console.log("success");
          },
        });
      });
    },
    gotoPay() {
      //判断订单是否可以支付
      var params = {
        agencyOpenid: this.agencyOpenid, //代付人openid
        orderNo: this.orderNo,
      };
      this.$api.canCreateAgentPayOrder(params).then((res) => {
        if (res.status == 1) {
          var url_config = window.location.origin + "/";
          // var WXurl = ""; 
          // if (process.env.NODE_ENV === "development"){
          //   WXurl = "https://content.jushoucat.com"; //测试环境
          //   }else if(process.env.NODE_ENV === "production"){
            // }
            var WXurl = this.$commonApi.PayURL(); //环境
          var URL =
            WXurl +
            "/payIndex.html?pageType=bookFindPay" +
            "&orderNo=" +
            this.orderNo +
            "&officialCode=" +
            this.officialCode +
            "&openid=" +
            this.agencyOpenid +
            "&configUrl=" +
            url_config;
          window.location.href = URL;
        } else {
          Toast({
            message: res.message,
          });
        }
      });
    },
    wechatLogin() {
      var code = this.$base.GetUrlParam("code");
      if (!code) {
        console.log(window.location.href);
        // snsapi_base//静默   snsapi_userinfo手动
        let uri = encodeURIComponent(window.location.href);
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
          this.$store.state.user.appid +
          "&redirect_uri=" +
          uri +
          "&response_type=code&scope=snsapi_base&state=state&wechat_redirect&connect_redirect=1#wechat_redirect";
      } else {
        this.getOpenId(code); //静默获取openId
      }
    },
    getOpenId(code) {
      var params = {
        code: code,
      };
      this.$api.getOpenid(params).then((res) => {
        if (res.status == 1) {
          //获取订单状态
          this.agencyOpenid = res.data.openid;
          this.getAgentPayInfo();
        }
      });
    },
    checkCity() {
      location.href='/'
    },
    buyChange(data) {
      if (data) {
        if (data == 1) {
          this.purchaseWholeBook = 1;
          this.goRead();
         // this.$router.push({
          //   path: "/pages/bookRead/index",
          //   query: {
          //     bookid: this.bookInfo.bookId,
          //     pageType: "bookCity",
          //     isEntranceData: isEntranceData,
          //   },
          // });
        } else if (data == 2) {
          this.showBuyMask = false;
          this.$router.push({
            path: "/pages/bookCharge/index",
            query: {
              bookId: this.bookInfo.bookId,
              needCurrency: this.countCurrency,
              pageType: "bookRead",
            },
          });
        }
      } else {
        this.showBuyMask = false;
      }
    },
    getContuneRead() {
      var params = {
        bookId: 0,
        chapterId: -1,
        continueRead: 1,
      };
      this.$api.getbookreadlog(params).then((res) => {
        if (res.status === 1) {
            this.bookInfo.chapterOrder = res.data.chapterPos;
            this.bookInfo.bookId = res.data.bookId;
            this.bookInfo.chapterId = res.data.chaptersId;
        } 
      });
    },
    	back(){
					this.$router.back()
			},
				changeStatus() {
				this.isRoute = !this.isRoute
			},
    goRead() {
      var params = {
        bookId: this.bookInfo.bookId,
        chapterId: this.bookInfo.chapterId, //章节排序order
        chapterorder: this.bookInfo.chapterOrder, //翻页标示 0:获取当前章节内容 1: 前一章 2：后一章,4从目录进入阅读器,3购买章节
        order: 0,
        booktype: "",
        isauto: 0,
        rechargeOrderNum: "", //订单编号
        purchaseWholeBook: this.purchaseWholeBook,
        currentPageType: 1,
      };
      this.$api.findChapterContentByChapterId(params).then((res) => {
        if (res.status == 1) {
          this.showBuyMask = false;
          this.purchaseWholeBook = 0;
          var isEntranceData = "";
          this.$router.push({
            path: "/pages/bookRead/index",
            query: {
              bookid: this.bookInfo.bookId,
              pageType: "bookFindPay",
              isEntranceData: isEntranceData,
            },
          });
        } else if (res.status == 3) {
          this.showBuyMask = true;
          this.countCurrency = res.data.wholeBookCurrency;
          this.userCurrency = res.data.accountCurrency;
        }else if (res.status == 100 || res.status == 200||res.status==4) {
          if (res.data) {
            // this.$router.push({
            //   path: "/pages/bookCharge/index",
            //   query: {
            //     bookId: this.bookInfo.bookId,
            //     chapterId: res.data.id,
            //     needCurrency: res.data.chapterPrice,
            //     pageType: "bookRead",
            //   },
            // });
            if(res.status==100&&res.data.priceType==3){
              this.$router.push({
                path: "/pages/bookCharge/index",
                query: {
                  bookId:this.bookInfo.bookId,
                  chapterId: res.data.id,
                  needCurrency: res.data.chapterPrice,
                  pageType: "bookRead",
                  priceType:res.data.priceType
                },
              });
              }else{
                this.$router.push({
                path: "/pages/bookCatalog/index",
                query: {
                  bookId:this.bookInfo.bookId,
                  pageType: "bookFindPay",
                },
              });
              } 
          }
        }
      });
    },
  },
};
</script>
<style scoped>
.mask-img {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0px;
  top: 0px;
  z-index: 9999;
  background-color: rgba(0,0,0,.8);
}
.mask-img>img:nth-child(1){
  position: absolute;
  right:21px;
  top:16px;
  width: 256px;
}
.mask-img>img:nth-child(2){
  width: 100%;
  position: absolute;
  bottom:0px;
  left:0px;
}
.success {
  background-color: #ffffff;
  height: 100%;
  padding-top: 60px;
  box-sizing: border-box;
  text-align: center;

}
.success > img {
  width: 96px;
  height: 96px;
  margin-bottom: 20px;
}
.success > p {
  font-size: 16px;
  color: #333333;
  margin-bottom: 50px;
  font-weight: bold;
}
.success > span,
.tips-bottom {
  font-size: 14px;
  color: #2d9ef2;
  letter-spacing: 0;
  display: block;
  text-align: center;
}
.tips-bottom {
  margin-top: 20px;
}
.title > p:nth-of-type(1) {
  font-size: 20px;
  color: #333333;
  text-align: center;
  margin-top: 45px;
  margin-bottom: 20px;
  font-weight: bold;
}
.title > p:nth-of-type(2) {
  font-size: 16px;
  color: #6f6f6f;
  margin-bottom: 20px;
  text-align: center;
}
.contaner {
  padding-top: calc(44px + env(safe-area-inset-top));
  background-color: #f5f5f5;
  height: 100%;
  box-sizing: border-box;
}
.card {
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(147, 147, 147, 0.5);
  border-radius: 14px;
  width: 252px;
  padding: 30px 0px;
  font-size: 14px;
  color: #333333;
  margin: 0 auto;
  text-align: center;
}
.card > p:nth-of-type(1) {
  font-size: 12px;
  color: #333333;
}
.card img {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: block;
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 8px;
}
.card > span {
  display: block;
  margin-bottom: 14px;
}
.card > p:nth-of-type(1) {
  font-size: 12px;
  color: #333333;
  padding: 0px 38px;
  line-height: 17px;
}
.line {
  opacity: 0.31;
  width: 242px;
  height: 0.5px;
  background-color: #979797;
  margin: 14px auto;
}
.card > p:nth-of-type(4) {
  font-size: 22px;
  color: #de3b34;
  line-height: 30px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.pay-btn {
  background-color: #de3b34;
  color: #ffffff;
  width: 209px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  border-radius: 5px;
  margin: 0 auto;
}
.nav{
  	height: calc(44px + env(safe-area-inset-top));
		padding: 7px 3px;
		background-color: #5F4C4C;
		position: fixed;
		top:0px;
		width: 100%;
		box-sizing: border-box;
		z-index: 99;
		    left:0;

}
	.nav-top{
		display: flex;
	
	}
	.nav-top-right{
		position: absolute;
		right:12px;
		top:10px;
			z-index: 999;
	}
	.icon_more {
		width: 16px;
		height: 16px;
		z-index: 999;
	}
	.route-mask {
		position: fixed;
		height: 100%;
		top: calc(44px + env(safe-area-inset-top));
		width: 100%;
		background-color: rgba(0, 0, 0, .5);
	  left:0;
		z-index: 9999;
	}

	.mask-content {
		background-color: #FFFFFF;
		overflow: hidden;
		padding-top: 25px;
	}

	.mask-content-view {
		float: left;
		width: 25%;
		margin-bottom:25px;
	}

	.mask-content-img{
		width: 27px;
		height: 27px;
		display: block;
		margin: 0 auto;
	}

	.mask-content-text {
		font-size: 12px;
		color: #666666;
		display: block;
		text-align: center;
	}
		.nav-top>.back{
			width:44px;
			height: 44px;
				position: absolute;
		left:0px;
		top:0px;
		text-align: center;
		}
	.nav-top>div.back>img{
		width: 9px;
		height: 16px;
		    margin-top: 17px;
	
	}
	.nav-top>span{
		width: 100%;
		display: block;
		font-size: 16px;
		font-weight: 700;
		line-height: 30px;
		text-align: center;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}


</style>



// WEBPACK FOOTER //
// src/view/bookFindPay/index.vue